import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { _serverUrl2 } from "../../config";

export const locationsApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: `${_serverUrl2}/user/` }),
  reducerPath: "locationsApi",
  endpoints: (build) => ({
    getLocationsByName: build.query({
      query: ({ id, tarih }) => ({
        url: `kullanici_gps/${id}`,
        params: { tarih },
      }),
    }),
  }),
});

export const { useGetLocationsByNameQuery } = locationsApi;
